import style from './CompanyTitle.module.css';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

// ✅ беремо переклад поточної мови з роутера
import { useParams } from 'react-router-dom';
import { getTranslation, normalizeLang } from '../../../../helpers/translation';

const FONT_URL = '/fonts/MyFont.woff2';

const CompanyTitle = () => {
  const { lang: rawLang } = useParams(); // undefined на корені
  const lang = normalizeLang(rawLang); // 'en' якщо undefined
  const t = getTranslation(lang); // переклад для поточної мови

  useEffect(() => {
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Artemida Studio',
      url: 'https://artemidastudio.com',
      description:
        t.heroSection?.companyDescription ||
        'We create custom websites of any complexity',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+48500815139',
        contactType: 'Customer Service',
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [t.heroSection?.companyDescription]);

  return (
    <>
      <Helmet>
        {/* ✅ Попереднє завантаження шрифту (camelCase у React) */}
        <link
          rel="preload"
          href={FONT_URL}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link rel="stylesheet" href="/styles/index.css" />
        <style>
          {`
            h1, h2 {
              font-family: 'MyFont', sans-serif;
              font-display: swap;
            }
          `}
        </style>
      </Helmet>

      <div className={style.companyContainer}>
        <h1 aria-label="Company name">Artemida Studio</h1>

        <h2 aria-label="Company description">
          {t.heroSection?.companyDescription}
        </h2>

        <a href="#contact" aria-label={t.heroSection?.contactUs}>
          <button
            className={style.contactUs}
            aria-label={t.heroSection?.contactUs}
          >
            {t.heroSection?.contactUs}
          </button>
        </a>
      </div>
    </>
  );
};

export default CompanyTitle;
